import React from 'react'
import { navigate, Link } from 'gatsby'
import Icon from './Icon'
import ModalOverlay from './ModalOverlay'
import { useQueryParams, StringParam, NumberParam } from 'use-query-params'
import { useSearchLocations, useGetGeoLocation } from 'src/core'
import { useAtom } from 'jotai'
import { placeNameAtom } from '../atoms'
const StoreHeaderSearch = ({ storeType }) => {
  const storeTypeDefault = 'Morrisons_GasStation_Franchise_MorrisonsDaily'
  const postCodeRef = React.useRef([])
  const {
    inputText,
    setInputText,
    postcodes,
    places,
    typing,
  } = useSearchLocations()
  const { loading, error: postcodesError, result: postcodesResult } = postcodes
  const { error: placesError, result: placesResult } = places
  const [showResults, setShowResults] = React.useState(false)
  const [, setQuery] = useQueryParams({
    postcode: StringParam,
    place: StringParam,
    lat: NumberParam,
    lon: NumberParam,
  })
  const {
    getGeolocation,
    longitude,
    latitude,
    geoError,
    fetchingPosition,
  } = useGetGeoLocation(false)
  const [, setPlaceName] = useAtom(placeNameAtom)
  React.useEffect(() => {
    if (!!longitude && !!latitude) {
      navigate(
        `/all/?lat=${latitude}&lon=${longitude}&storeType=${storeTypeDefault}`
      )
    }
  }, [setQuery, longitude, latitude, storeType])

  function handleSearch() {
    if (inputText?.length < 3) return
    const noSpaceString = inputText?.replace(/\s/g, '')
    const upperPostcode = noSpaceString.toUpperCase()
    const isPostcode = /\d/.test(noSpaceString)

    if (upperPostcode.startsWith('JE')) {
      let latitude = 49.2138
      let longitude = -2.1311
      navigate(
        `/all/?lat=${latitude}&lon=${longitude}&storeType=${storeTypeDefault}`
      )
    } else if (upperPostcode.startsWith('GY')) {
      let latitude = 49.4657
      let longitude = -2.5353
      navigate(
        `/all/?lat=${latitude}&lon=${longitude}&storeType=${storeTypeDefault}`
      )
    } else if (isPostcode) {
      const formattedPostcode = noSpaceString?.toUpperCase()
      navigate(
        `/all/?postcode=${formattedPostcode}&storeType=${storeTypeDefault}`
      )
    } else {
      navigate(`/all/?place=${inputText}&storeType=${storeTypeDefault}`)
    }

    setShowResults(false)
  }

  function handleKeyDown(event) {
    if (event.keyCode === 13) {
      handleSearch()
    }
    if (event.keyCode === 27) {
      setInputText('')
    }
    if (event.keyCode === 40) {
      postCodeRef?.current?.[0]?.focus()
    }
  }

  function handlePostcodeKeydown(event, i) {
    if (event.keyCode === 38) {
      //up
      if (i === 0) {
        postCodeRef?.current?.[
          postcodesResult?.data?.result?.length - 1
        ]?.focus()
      }
      postCodeRef?.current?.[i - 1]?.focus()
    }
    if (event.keyCode === 40) {
      // down
      if (i === postcodesResult?.data?.result?.length - 1) {
        postCodeRef?.current?.[0]?.focus()
      }
      postCodeRef?.current?.[i + 1]?.focus()
    }
  }

  function handleClose() {
    setShowResults(false)
  }

  let dataLayer

  if (typeof window !== `undefined`) {
    dataLayer = window.dataLayer
  }

  function clickCurrentLocation() {
    if (dataLayer && dataLayer.push) {
      dataLayer.push({
        event: 'currentLocationSearch',
      })
    }
  }

  function renderSearchResults() {
    let component
    switch (true) {
      case postcodesResult?.data?.status === 200 &&
        !postcodesResult?.data?.result?.length &&
        placesResult?.data?.status === 200 &&
        !placesResult?.data?.result?.length:
        component = (
          <div className="p-3 text-base font-medium">
            Sorry, we have no matching locations
          </div>
        )
        break
      case (postcodesError || placesError) && true:
        component = (
          <div className="p-3 mb-5 text-lg">
            Search is not available at this time. Please try again later.
          </div>
        )
        break
      case !!postcodesResult?.data?.result?.length ||
        !!placesResult?.data?.result?.length:
        component = (
          <section className="flex flex-col p-3 pt-4 text-sm font-semibold md:text-base lg:text-lg">
            {postcodesResult?.data?.result?.length > 0 ? (
              <h2 className="my-1 text-sm font-semibold uppercase lg:text-md text-body-light">
                Postcodes
              </h2>
            ) : null}
            {postcodesResult?.data?.result?.map((postcode, i) => {
              if (postcode.startsWith('JE')) {
                let latitude = 49.2138
                let longitude = -2.1311
                return (
                  <Link
                    key={i}
                    className="px-2 py-2 m-0 -mx-2 border border-t-0 border-r-0 border-l-0 border-body-lightest hover:bg-body-lightest focus:bg-body-lightest last:border-b-0"
                    ref={el => (postCodeRef.current[i] = el)}
                    onKeyDown={event => handlePostcodeKeydown(event, i)}
                    onClick={() => {
                      setShowResults(false)
                    }}
                    to={`/all/?lat=${latitude}&lon=${longitude}&storeType=${storeTypeDefault}`}
                  >
                    {postcode}
                  </Link>
                )
              } else if (postcode.startsWith('GY')) {
                let latitude = 49.4657
                let longitude = -2.5353
                return (
                  <Link
                    key={i}
                    className="px-2 py-2 m-0 -mx-2 border border-t-0 border-r-0 border-l-0 border-body-lightest hover:bg-body-lightest focus:bg-body-lightest last:border-b-0"
                    ref={el => (postCodeRef.current[i] = el)}
                    onKeyDown={event => handlePostcodeKeydown(event, i)}
                    onClick={() => {
                      setShowResults(false)
                    }}
                    to={`/all/?lat=${latitude}&lon=${longitude}&storeType=${storeTypeDefault}`}
                  >
                    {postcode}
                  </Link>
                )
              } else {
                const formattedPostcode = postcode?.replace(/\s/g, '')
                return (
                  <Link
                    key={i}
                    className="px-2 py-2 m-0 -mx-2 border border-t-0 border-r-0 border-l-0 border-body-lightest hover:bg-body-lightest focus:bg-body-lightest last:border-b-0"
                    ref={el => (postCodeRef.current[i] = el)}
                    onKeyDown={event => handlePostcodeKeydown(event, i)}
                    onClick={() => {
                      setShowResults(false)
                    }}
                    to={`/all/?postcode=${formattedPostcode}&storeType=${storeTypeDefault}`}
                  >
                    {postcode}
                  </Link>
                )
              }
            })}

            {placesResult?.data?.result?.length > 0 ? (
              <h2 className="my-1 text-sm font-semibold uppercase lg:text-md text-body-light">
                Places
              </h2>
            ) : null}

            {placesResult?.data?.result?.map((place, i) => {
              return (
                <Link
                  key={i}
                  className="px-2 py-2 m-0 -mx-2 border border-t-0 border-r-0 border-l-0 border-body-lightest hover:bg-body-lightest focus:bg-body-lightest last:border-b-0"
                  ref={el => (postCodeRef.current[i] = el)}
                  onKeyDown={event => handlePostcodeKeydown(event, i)}
                  onClick={() => {
                    setShowResults(false)
                    const pName = `${place?.name_1},
                    ${
                      place?.county_unitary ? `${place.county_unitary}, ` : ''
                    } ${place?.outcode}`
                    setPlaceName(pName)
                  }}
                  to={`/all/?lat=${place.latitude}&lon=${place.longitude}&storeType=${storeTypeDefault}`}
                >
                  {place?.name_1},{' '}
                  {place?.county_unitary ? `${place.county_unitary}, ` : null}
                  {place?.outcode}
                </Link>
              )
            })}
          </section>
        )
        break
      default:
        component = null
        break
    }
    return component
  }

  return (
    <>
      <div className="relative flex-1">
        <div className="flex justify-between">
          <div className="flex relative flex-1 justify-between items-center px-2 mr-2 bg-white rounded-lg border text-secondary border-primary-light">
            <Icon
              icon={loading && !typing ? 'searchIconLoading' : 'searchIcon'}
              className="w-6 h-6 fill-secondary sm:w-8 sm:h-8 md:w-10 md:h-10"
            />
            <input
              name="q"
              value={inputText}
              autoComplete="off"
              data-cy="search-input"
              aria-label="search box"
              onKeyDown={handleKeyDown}
              onChange={e => {
                setInputText(e.target.value)
                setShowResults(true)
              }}
              placeholder="Enter postcode or location"
              className="px-2 py-3 w-full font-light truncate bg-transparent outline-none text-body text-md placeholder-body caret-tertiary"
            ></input>
            <label htmlFor="q" className="hidden" aria-hidden="true">
              Search Postcode or location
            </label>
            <button
              className={`flex items-center justify-center rounded py-2 disabled:bg-opacity-80 group  ${geoError &&
                'bg-body-lighter hover:bg-body-lighter bg-opacity-60 hover:bg-opacity-60 cursor-not-allowed'}`}
              onClick={() => {
                setPlaceName('')
                clickCurrentLocation()
                if (!!latitude && !!longitude) {
                  setQuery({
                    lon: longitude,
                    lat: latitude,
                    postcode: undefined,
                  })
                } else {
                  getGeolocation()
                }
              }}
              disabled={fetchingPosition}
            >
              <Icon
                icon={fetchingPosition ? 'searchIconLoading' : 'location'}
                className={`w-5 h-5 fill-secondary group-hover:fill-body ${geoError &&
                  'group-hover:fill-body-light fill-body-light'}`}
              />
            </button>
          </div>
          <button
            className="flex justify-center items-center px-2 py-1 rounded md:px-3 text-body hover:text-white bg-tertiary hover:bg-primary disabled:bg-opacity-80 group"
            onClick={handleSearch}
          >
            <span className="text-sm font-semibold whitespace-nowrap text-body group-hover:text-white">
              Search
            </span>
          </button>
        </div>

        {inputText.length > 2 && !loading && showResults ? (
          <div className="absolute right-0 z-30 px-0 w-[calc(100vw-4rem)] sm:w-full">
            <div className="overflow-hidden pb-0 mt-8 text-left bg-white rounded-lg shadow-2xl lg:px-4">
              {renderSearchResults()}
            </div>
          </div>
        ) : null}

        {geoError && geoError.code === 1 && !inputText.length ? (
          <div className="absolute top-12 p-3 mt-8 w-full text-white rounded-lg bg-body-dark">
            You have disabled geolocation for this website.
          </div>
        ) : null}
      </div>
      <ModalOverlay
        isShowing={inputText.length > 2 && showResults && !loading}
        onClick={handleClose}
      />
    </>
  )
}

export default StoreHeaderSearch
